import { map, reduce } from 'ramda'

import SimpleDate from 'app/common/classes/simple-date'

const subjectColumnWidth = 150 as const
const totalColumnWidth = 140 as const

export enum ColumnKey {
  Subject = 'subject',
  Total = 'total',
}

export const createDinamicColumnKey = (date: SimpleDate) => {
  return `date_${date.getStringFormatted('YYYY-MM-DD')}`
}

export const columnKeysLeft = [ColumnKey.Subject]
export const columnKeysLeftHeaders = [[ColumnKey.Subject]]

export const createColumnKeysMain = (dates: Array<SimpleDate>) => {
  return dates.map((date) => createDinamicColumnKey(date))
}

export const createColumnKeysMainHeaders = (dates: Array<SimpleDate>) => {
  return [createColumnKeysMain(dates)]
}

export const columnKeysRight = [ColumnKey.Total]
export const columnKeysRightHeaders = [[ColumnKey.Total]]

const headerCells = {
  [ColumnKey.Subject]: '',
  [ColumnKey.Total]: 'Всего, {currency}',
}

export const createHeaderCells = (
  dates: Array<SimpleDate>,
  periodType: 'monthly' | 'daily',
  currency: string,
) => {
  return reduce(
    (acc, date) => {
      const key = createDinamicColumnKey(date)
      acc[key] = date.getStringFormatted(periodType === 'monthly' ? 'MMMM YYYY' : 'DD.MM')
      return acc
    },
    map<Record<string, string>, Record<string, string>>(
      (value) => value.replace('{currency}', currency),
      headerCells,
    ),
    dates,
  )
}

const headerCellsProps = {
  [ColumnKey.Subject]: { alignRight: true, width: subjectColumnWidth, bgFilled: true },
  [ColumnKey.Total]: { alignRight: true, width: totalColumnWidth, bgFilled: true },
}

export const createHeaderCellsProps = (dates: Array<SimpleDate>) => {
  return reduce(
    (acc, date) => {
      const key = createDinamicColumnKey(date)
      acc[key] = { alignRight: true, bgFilled: true }
      return acc
    },
    headerCellsProps,
    dates,
  )
}

const cellsProps = {
  [ColumnKey.Subject]: { alignRight: true, width: subjectColumnWidth },
  [ColumnKey.Total]: { alignRight: true, width: totalColumnWidth },
}

export const createCellsProps = (dates: Array<SimpleDate>) => {
  return reduce(
    (acc, date) => {
      const key = createDinamicColumnKey(date)
      acc[key] = { alignRight: true }
      return acc
    },
    cellsProps,
    dates,
  )
}

const footerCellsProps = {
  [ColumnKey.Subject]: { alignRight: true, width: subjectColumnWidth, bold: true },
  [ColumnKey.Total]: { alignRight: true, width: totalColumnWidth, bold: true },
}

export const createFooterCellProps = (dates: Array<SimpleDate>) => {
  return reduce(
    (acc, date) => {
      const key = createDinamicColumnKey(date)
      acc[key] = { alignRight: true, highlighted: true, bold: true }
      return acc
    },
    footerCellsProps,
    dates,
  )
}
